import { useLayoutEffect, useRef } from "react"

export const useHeldHeight = <T extends HTMLElement>(settled: boolean) => {
  const ref = useRef<T>(null)
  const settledHeight = useRef<number | undefined>(undefined)
  useLayoutEffect(() => {
    const element = ref.current
    if (!element) return
    if (settled) {
      element.style.minHeight = ""
      settledHeight.current = element.offsetHeight
    } else if (settledHeight.current !== undefined) {
      element.style.minHeight = `${settledHeight.current}px`
    }
  })
  return ref
}
